import { render, staticRenderFns } from "./addshopticket.vue?vue&type=template&id=f65be098&"
import script from "./addshopticket.vue?vue&type=script&lang=js&"
export * from "./addshopticket.vue?vue&type=script&lang=js&"
import style0 from "./addshopticket.vue?vue&type=style&index=0&id=f65be098&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports